import { Component, Inject, OnInit } from '@angular/core';
import { Localidad } from 'src/app/models/localidad.model';
import { CantidadBoletasComponent } from '../cantidad-boletas/cantidad-boletas.component';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { LocalidadId } from 'src/app/models/mapa-models/localidadmapa.model';
import { ClientePagos } from 'src/app/models/cliente-pagos.model';

@Component({
    selector: 'app-localidad-seleccion',
    templateUrl: './localidad-seleccion.component.html',
    styleUrls: ['./localidad-seleccion.component.css'],
    standalone: false
})
export class LocalidadSeleccionComponent implements OnInit {

  localidadesIds: LocalidadId[] =[];
  localidades: Localidad[] =[]
  cliente: ClientePagos
  eventoId: number;
  codigoVenta;
  localidad: Localidad
  localidadesFiltradas: Localidad[] = [];


  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.localidadesIds = this.data.localidadesIds;
    this.localidades = this.data.localidades;
    this.cliente =this.data.cliente;
    this.eventoId=this.data.eventoId;
    this.codigoVenta=this.data.codigoVenta;
    this.localidadesFiltradas = this.localidades.filter(localidad => this.localidadesIds.some(item => item.id === localidad.id));
  }

  cantidadBoletas(pLocalidad: Localidad) {

    this.localidad = this.localidades.find(localidad => localidad.id == pLocalidad.id);

    const dialogRef = this.dialog.open(CantidadBoletasComponent, {
      
      width: '600px',
      
      data: {
          localidad: this.localidad,
          cliente: this.cliente,
          eventoId: this.eventoId,
          codigoVenta:this.codigoVenta
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.dialog.closeAll();

      this.ngOnInit();

    });
  }
}
